export default "__VITE_ASSET__Dh2ICyHW__"